import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { CapacidadTecnicaService } from "./capacidad-tecnica.service";
import { CapacidadTecnicaEntry } from "src/app/shared/entrys/capacidad-tecnica.entry";
import { CapacidadOperativaService } from "./capacidad-operativa.service";
import { CapacidadOperativaEntry } from "src/app/shared/entrys/capacidad-operativa.entry";
import { DataSharedService } from "src/app/shared/services/data-shared.service";
import { RNTPrestadorEntry } from "src/app/shared/entrys/rnt-prestador.entry";
import { CompletaInformacionService } from "../completa-informacion/completa-informacion.service";
import { DatoSolicitudSharedModel } from "src/app/shared/models/dato-solicitud-shared.model";
import { ConfirmeValidators } from "src/app/shared/directives/validators/confirme-validators";
import { RatificaInformacionEntry } from "src/app/shared/entrys/ratificacion-informacion.entry";
import { TipoRnt } from "src/app/shared/enumeraciones/tipo-rnt.enum";
import { AuthService } from "src/app/shared/services/auth.service";
import { TipoPrestador } from "src/app/shared/enumeraciones/tipo-prestador.enum";
import { AlertsService } from "src/app/shared/services/alerts.service";
import { AyudasService } from "src/app/components/contenido/containers/ayudas/ayudas.service";
import { TipoSolicitud } from "src/app/shared/enumeraciones/tipo-solicitud.enum";
import { TipoCapacidad } from "src/app/shared/enumeraciones/tipo-capacidad.enum";
import { TipoPrestadorId } from "src/app/shared/enumeraciones/tipo-prestador-id.enum";
import { PlataformasElectronicasDigitalesFlow } from "src/app/shared/flows/plataformas-electronicas-digitales.flow";
import { EstadosRnt } from "src/app/shared/enumeraciones/estados-rnt.enum";


@Component({
  selector: "app-capacidad",
  templateUrl: "./capacidad.component.html",
  styleUrls: ["./capacidad.component.scss"],
})
export class CapacidadComponent implements OnInit {
  @Output()
  pasoActual: EventEmitter<number> = new EventEmitter();

  headersCapacidadTecnica: Array<string>;
  headersCapacidadOperativa: Array<string>;
  formCapacidadTecnica: FormGroup;
  formCapacidadOperativa: FormGroup;
  capacidadesTecnicas: Array<CapacidadTecnicaEntry> = [];
  formacionEmpleo: Array<any> = [];
  capacidadTecnica: Array<any> = [];
  capacidadesOperativas: Array<CapacidadOperativaEntry> = [];
  selectCapacidadTecnica: CapacidadTecnicaEntry;
  selectCapacidadOperativa: CapacidadOperativaEntry;
  rnt: RNTPrestadorEntry;
  datoSolicitudSharedModel: DatoSolicitudSharedModel;
  capacidadTecnicaVieja: CapacidadTecnicaEntry;
  capacidadOperativaVieja: CapacidadOperativaEntry;
  ratificaInformacion: RatificaInformacionEntry;
  idCategoria: any;

  public Paso2Norequerido: boolean;
  public labelTiCapacidad: string;

  public Titulo_Capacidad_tecnica: string = "";
  public Texto_Capacidad_tecnica: string = "";
  public Titulo_Capacidad_Operativa: string = "";
  public Texto_Capacidad_Operativa: string = "";

  // hostingSoftware
  hostingSoftwareId : number;
  SubDataTypeOtherId : number;
  hostingSoftwareData : Array<any> = [];
  // hostingSoftware

  // V2
  requeridoCapTecnica: boolean;
  mostrarCapTecnica: boolean;
  requeridoCapOperativa: boolean;
  mostrarCapOperativa: boolean;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private capacidadTecnicaService: CapacidadTecnicaService,
    private completaInformacionService: CompletaInformacionService,
    private capacidadOperativaService: CapacidadOperativaService,
    private dataSharedService: DataSharedService,
    private authService: AuthService,
    private alertService: AlertsService,
    public ayudaService: AyudasService
  ) {
    this.Paso2Norequerido = false;
    this.formCapacidadTecnica = formBuilder.group({});
    this.capacidadTecnicaVieja = null;
    this.capacidadOperativaVieja = null;
    this.capacidadesOperativas = [];
    this.capacidadesTecnicas = [];
    this.dataSharedService.data$.subscribe((resultado) => {
      this.labelTiCapacidad = "Elemento (electrónico, magnético, mecánico)";

      this.datoSolicitudSharedModel = resultado as DatoSolicitudSharedModel;
      this.rnt = this.datoSolicitudSharedModel.data as RNTPrestadorEntry;
      this.ratificaInformacion = this.datoSolicitudSharedModel.data
        .ratificaInformacion as RatificaInformacionEntry;

      if (this.rnt.matricula === "-") {

        this.formCapacidadTecnica = formBuilder.group({
          descripcion: [""],
          cantidad: [
            "",
            [
              Validators.min(1),
              Validators.max(9999999),
              ConfirmeValidators.numberValidator,
            ],
          ],
          tipo_capacidad_tecnica_id: [""],
          capacidad_tecnica_id: [""],
          codigo_camara: [this.rnt.codigo_camara],
          detalle_solicitud_id: [this.rnt.detalle_solicitud_id],
          descripcion_tipo: [""],
          activo: [true],
          sub_tipo_capacidad_tecnica_id : [null]
        });

        this.formCapacidadOperativa = formBuilder.group({
          formacion_empleado_id: [""],
          descripcion: [""],
          numero_empleados: [
            "",
            [
              Validators.min(0),
              Validators.max(99999),
              ConfirmeValidators.numberValidator,
            ],
          ],
          capacidad_operativa_id: [""],
          codigo_camara: [this.rnt.codigo_camara],
          detalle_solicitud_id: [this.rnt.detalle_solicitud_id],
          activo: [true],
        });

        this.Paso2Norequerido = true;
      } else {
        this.formCapacidadTecnica = formBuilder.group({
          descripcion: ["", Validators.required],
          cantidad: [
            "",
            [
              Validators.required,
              ,
              Validators.min(1),
              Validators.max(9999999),
              ConfirmeValidators.numberValidator,
            ],
          ],
          tipo_capacidad_tecnica_id: ["", Validators.required],
          capacidad_tecnica_id: [""],
          codigo_camara: [this.rnt.codigo_camara],
          detalle_solicitud_id: [this.rnt.detalle_solicitud_id],
          descripcion_tipo: [""],
          activo: [true],
          sub_tipo_capacidad_tecnica_id : [null]
        });

        this.formCapacidadOperativa = formBuilder.group({
          formacion_empleado_id: ["", Validators.required],
          descripcion: [""],
          numero_empleados: [
            "",
            [
              Validators.required,
              Validators.min(0),
              Validators.max(99999),
              ConfirmeValidators.numberValidator,
            ],
          ],
          capacidad_operativa_id: [""],
          codigo_camara: [this.rnt.codigo_camara],
          detalle_solicitud_id: [this.rnt.detalle_solicitud_id],
          activo: [true],
        });
      }
    });
  }

  ngOnInit() {
    this.pasoActual.emit(2);
    if(this.datoSolicitudSharedModel.data.estado_rnt_id === EstadosRnt.SuspendidoPorNoRenovar &&  
      this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Reactivacion){
        this.pasoActual.emit(3);
    }

    this.capacidadesTecnicas = [] as Array<CapacidadTecnicaEntry>;
    this.capacidadesOperativas = [] as Array<CapacidadOperativaEntry>;
    this.headersCapacidadTecnica = [
      "Elemento",
      "Descripción",
      "Cantidad",
      "SubTipo",
      "Acción"
    ];
    this.headersCapacidadOperativa = [
      "Formación de empleados",
      "Número de empleados",
      "Acción",
    ];

    if(this.datoSolicitudSharedModel.data.categoria_id === 0){
      this.idCategoria = this.datoSolicitudSharedModel.data.categoriaId;
    } else {
      this.idCategoria = this.datoSolicitudSharedModel.data.categoria_id;
    }
   
    if (
      (this.datoSolicitudSharedModel.data.estado_rnt_id ===
        EstadosRnt.SuspendidoPorNoRenovar &&  
        this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Reactivacion) ||
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Renovacion ||
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Actualizacion
    ) {
      this.capacidadTecnicaService
        .getMigracion(this.formCapacidadTecnica.value)
        .subscribe((resultado) => {
          if (resultado.result) {
            this.capacidadTecnicaVieja =
              resultado.data as CapacidadTecnicaEntry;
          }
        });
    }

    if (
      (this.datoSolicitudSharedModel.data.estado_rnt_id ===
        EstadosRnt.SuspendidoPorNoRenovar &&  
        this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Reactivacion) ||
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Renovacion ||
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Actualizacion
    ) {
      this.capacidadOperativaService
      .getMigracion(this.formCapacidadOperativa.value)
      .subscribe((resultado) => {
        if (resultado.result) {
          this.capacidadOperativaVieja =
          resultado.data as CapacidadOperativaEntry;
        }
      });
    }

    this.getCapacidadesTecnicas();
    this.getCapacidadTecnicaSelected();
    this.getCapacidadOperativa();
    this.getCapacidadOperativaSelected();
    this.InitGetParametroCapacidadTecnica();
    this.InitGetParametroCapacidadOperativa();
    this.getConfiguracionCapacidadTecnica();
    this.getConfiguracionCapacidadOperativa();
  }

  // Obtener listado de las CT para el dropdown
  getCapacidadesTecnicas() {
    this.capacidadOperativaService
    .getCapacidadTecnica(this.idCategoria)
    .subscribe((resultado) => {
      if (resultado.result) {
        this.capacidadTecnica = resultado.data as Array<any>;
        this.catchHostingSoftwareId();
        this.getHostingSoftwareList();
      }
    });
  }

  // Obtener listado de las CT seleccionadas
  getCapacidadTecnicaSelected(){
    //this.formCapacidadTecnica.value
    this.capacidadTecnicaService
    .get(this.formCapacidadTecnica.value)
    .subscribe((resultado) => {
      if (resultado.result) {
        this.capacidadesTecnicas =
        resultado.data as Array<CapacidadTecnicaEntry>;

        this.statusBtnNext();
      }
    });
  }

  // Obtener listado de las CO (DROPDOWN)
  getCapacidadOperativa(){
    this.capacidadOperativaService
    .getFormacionEmpleo(null)
    .subscribe((resultado) => {
      if (resultado.result) {
        this.formacionEmpleo = resultado.data as Array<any>;
      }
    });
  }

  // Obtener listado de las CO seleccionadas
  getCapacidadOperativaSelected(){
    this.capacidadOperativaService
    .get(this.formCapacidadOperativa.value)
    .subscribe((resultado) => {
      if (resultado.result) {
        this.capacidadesOperativas =
        resultado.data as Array<CapacidadOperativaEntry>;

        this.statusBtnNext();
      }
    });
  }

  capacidadTecnicaChange( e : any ) {
    const { name, value } = e.target;

    if (this.hostingSoftwareId === Number(value)) {
      this.formCapacidadTecnica.controls.sub_tipo_capacidad_tecnica_id.setValidators([Validators.required]);
    } else {
      this.formCapacidadTecnica.controls.sub_tipo_capacidad_tecnica_id.setValue(null);
      this.formCapacidadTecnica.controls.sub_tipo_capacidad_tecnica_id.clearValidators();
      this.formCapacidadTecnica.controls.sub_tipo_capacidad_tecnica_id.updateValueAndValidity();
    }
  }

  // hostingSoftware
  catchHostingSoftwareId() {
    this.hostingSoftwareId = this.capacidadTecnica.find((item) => item.descripcion.includes('SOFTWARE DE ALOJAMIENTO'))?.tipo_capacidad_tecnica_id;
  }

  getHostingSoftwareList() {
    if(this.hostingSoftwareId){
      this.capacidadOperativaService.getHostingSoftware(this.hostingSoftwareId).subscribe(
        (res) => {
          if (res.result) {
            const { data } = res;
            this.hostingSoftwareData = data;
            this.catchSubDataTypeOtherId();
          }
        }
      )
    }
  }

  catchSubDataTypeOtherId() {
    this.SubDataTypeOtherId = this.hostingSoftwareData.find((item) => item.descripcion.includes('Otro'))?.sub_tipo_capacidad_tecnica_id;
  }

  hostingSoftwareChange( e : any ) {
    const { name, value } = e.target;
    (this.SubDataTypeOtherId === value)
    ? this.formCapacidadTecnica.controls.descripcion.setValidators([Validators.required])
    : this.formCapacidadTecnica.controls.descripcion.clearValidators();
  }
  // hostingSoftware

  goPaso() {
    if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Inmuebles || this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Guia) {
      this.UpdateDetalleSolicitud();
    } else {
      if(this.requeridoCapTecnica && !this.requeridoCapOperativa){ // Requerido la CT y la CO No
        if (this.capacidadesTecnicas) {
          this.UpdateDetalleSolicitud();
        } else {
          this.alertService.warn(
            "Asegúrese de haber registrado sus capacidades técnicas y operativas",
            null,
            null
          );
        }
      } else if(!this.requeridoCapTecnica && this.requeridoCapOperativa){ // Requerido la CO y la CT No
        if (this.capacidadesOperativas) {
          this.UpdateDetalleSolicitud();
        } else {
          this.alertService.warn(
            "Asegúrese de haber registrado sus capacidades técnicas y operativas",
            null,
            null
          );
        }
      } else if(this.requeridoCapTecnica && this.requeridoCapOperativa){ // Requerido la CO y la CT
        if (this.capacidadesTecnicas && this.capacidadesOperativas) {
          this.UpdateDetalleSolicitud();
        } else {
          this.alertService.warn(
            "Asegúrese de haber registrado sus capacidades técnicas y operativas",
            null,
            null
          );
        }
      } else if(!this.requeridoCapTecnica && !this.requeridoCapOperativa){ // No Requerido la CO y la CT
        this.UpdateDetalleSolicitud();
      }
    }
  }

  //#region Actualizar Detalle solicitud
  UpdateDetalleSolicitud() {
    this.rnt.paso = 2;
    if(this.datoSolicitudSharedModel.data.estado_rnt_id ===
      EstadosRnt.SuspendidoPorNoRenovar &&  
      this.datoSolicitudSharedModel.tipo_solicitud ===
      TipoSolicitud.Reactivacion){
        this.rnt.paso = 3;
    }
    if (
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.ReactivacionAnticipada ||
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Renovacion ||
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Actualizacion
    ) {
      const rnt: RNTPrestadorEntry = {
        ...this.rnt,
        tipo_solicitud_id: this.datoSolicitudSharedModel.tipo_solicitud,
      };
      this.completaInformacionService
        .update({ ...this.rnt, ...this.ratificaInformacion })
        .subscribe((resultado) => {
          if (resultado.result) {
            this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
              data: {
                ...rnt,
                ratificaInformacion: this.ratificaInformacion,
                nit: this.datoSolicitudSharedModel.data.nit,
              } as RNTPrestadorEntry,
              tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
              tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
              estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud,
            });
            this.router.navigate(["/solicitud/tipo-establecimiento"]);
          }
        });
    } else {
      this.completaInformacionService
        .update(this.rnt)
        .subscribe((resultado) => {
          if (resultado.result) {
            this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
              data: this.rnt as RNTPrestadorEntry,
              tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
              tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
              estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud,
            });
            this.router.navigate(["/solicitud/tipo-establecimiento"]);
          }
        });
    }
  }

  //#endregion

  //#region Capacidad Tecnica
  onAgregarCapacidadTecnica() {
    this.capacidadTecnicaService
      .create({
        ...this.formCapacidadTecnica.value,
        codigo_camara: this.rnt.codigo_camara,
        detalle_solicitud_id: this.rnt.detalle_solicitud_id,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          if (
            (this.datoSolicitudSharedModel.data.estado_rnt_id ===
              EstadosRnt.SuspendidoPorNoRenovar &&  
              this.datoSolicitudSharedModel.tipo_solicitud ===
              TipoSolicitud.Reactivacion) ||
            this.datoSolicitudSharedModel.tipo_solicitud ===
              TipoSolicitud.Renovacion ||
            this.datoSolicitudSharedModel.tipo_solicitud ===
              TipoSolicitud.Actualizacion
          ) {
            this.ratificaInformacion.cantidad_modificaciones += 1;
            this.completaInformacionService
              .confirmarCambio({ ...this.rnt, ...this.ratificaInformacion })
              .subscribe();

              this.formCapacidadTecnica.controls.sub_tipo_capacidad_tecnica_id.setValue(null);
              this.hostingSoftwareId = 27;
          }

          this.capacidadTecnicaService
            .get(this.rnt)
            .subscribe((resultadoGet) => {
              if (resultadoGet.result) {
                this.capacidadesTecnicas =
                  resultadoGet.data as Array<CapacidadTecnicaEntry>;
                  this.statusBtnNext();
              }
            });

          this.formCapacidadTecnica.controls.sub_tipo_capacidad_tecnica_id.setValue(null);
          this.formCapacidadTecnica.controls.sub_tipo_capacidad_tecnica_id.clearValidators();
          this.formCapacidadTecnica.controls.sub_tipo_capacidad_tecnica_id.updateValueAndValidity();
          this.formCapacidadTecnica.reset();
          this.hostingSoftwareId = 27;
        }
      });
  }

  onModificarCapacidadTecnica() {
    this.capacidadTecnicaService
      .update(this.formCapacidadTecnica.value)
      .subscribe((resultado) => {
        if (resultado.result) {
          if (
            (this.datoSolicitudSharedModel.data.estado_rnt_id ===
              EstadosRnt.SuspendidoPorNoRenovar &&  
              this.datoSolicitudSharedModel.tipo_solicitud ===
              TipoSolicitud.Reactivacion) ||
            this.datoSolicitudSharedModel.tipo_solicitud ===
              TipoSolicitud.Renovacion ||
            this.datoSolicitudSharedModel.tipo_solicitud ===
              TipoSolicitud.Actualizacion
          ) {
            this.ratificaInformacion.cantidad_modificaciones += 1;
            this.completaInformacionService
              .confirmarCambio({ ...this.rnt, ...this.ratificaInformacion })
              .subscribe();

              //this.formCapacidadTecnica.value.sub_tipo_capacidad_tecnica_id = null;
              //this.hostingSoftwareId = 27;
          }

          let capacidadTecnica = this.formCapacidadTecnica
            .value as CapacidadTecnicaEntry;

          capacidadTecnica.descripcion_tipo = this.capacidadTecnica.find(
            (buscar) => {
              if (
                this.formCapacidadTecnica.value.tipo_capacidad_tecnica_id ===
                buscar.tipo_capacidad_tecnica_id
              ) {
                return buscar;
              }
            }
          )?.descripcion;

          if(capacidadTecnica.sub_tipo_capacidad_tecnica_id){

            capacidadTecnica.descripcion_sub_tipo = this.hostingSoftwareData.find(
              (buscar) => {
                if (
                  Number(this.formCapacidadTecnica.value.sub_tipo_capacidad_tecnica_id) ===
                  buscar.sub_tipo_capacidad_tecnica_id
                ) {
                  return buscar;
                }
              }
            )?.descripcion;

          }

          this.capacidadesTecnicas[
            this.capacidadesTecnicas.indexOf(this.selectCapacidadTecnica)
          ] = capacidadTecnica as CapacidadTecnicaEntry;

          this.getCapacidadesTecnicas();

          this.formCapacidadTecnica.value.sub_tipo_capacidad_tecnica_id = null;
          this.hostingSoftwareId = 27;
          this.formCapacidadTecnica.controls.sub_tipo_capacidad_tecnica_id.clearValidators();
          this.formCapacidadTecnica.controls.sub_tipo_capacidad_tecnica_id.updateValueAndValidity();
          this.selectCapacidadTecnica = null;
          this.formCapacidadTecnica.reset();
          this.statusBtnNext();
        }
      });
  }

  onCargarEditarTecnica(entry: CapacidadTecnicaEntry) {
    this.formCapacidadTecnica.setValue({
      descripcion: entry.descripcion,
      cantidad: entry.cantidad,
      tipo_capacidad_tecnica_id: entry.tipo_capacidad_tecnica_id,
      capacidad_tecnica_id: entry.capacidad_tecnica_id,
      codigo_camara: this.rnt.codigo_camara,
      detalle_solicitud_id: this.rnt.detalle_solicitud_id,
      descripcion_tipo: entry.descripcion_tipo,
      sub_tipo_capacidad_tecnica_id: entry.sub_tipo_capacidad_tecnica_id,
      activo: true,
    });
    this.selectCapacidadTecnica = entry;
  }

  onEliminarCapacidadTecnica(entry: CapacidadTecnicaEntry) {
    this.capacidadTecnicaService.delete(entry).subscribe((resultado) => {
      if (resultado.result) {
        if (
          (this.datoSolicitudSharedModel.data.estado_rnt_id ===
            EstadosRnt.SuspendidoPorNoRenovar &&  
            this.datoSolicitudSharedModel.tipo_solicitud ===
            TipoSolicitud.Reactivacion) ||
          this.datoSolicitudSharedModel.tipo_solicitud ===
            TipoSolicitud.Renovacion ||
          this.datoSolicitudSharedModel.tipo_solicitud ===
            TipoSolicitud.Actualizacion
        ) {
          this.ratificaInformacion.cantidad_modificaciones += 1;
          this.completaInformacionService
            .confirmarCambio({ ...this.rnt, ...this.ratificaInformacion })
            .subscribe();
        }
        this.capacidadesTecnicas.splice(
          this.capacidadesTecnicas.indexOf(entry),
          1
        );

        this.formCapacidadTecnica.controls.sub_tipo_capacidad_tecnica_id.setValue(null);
        this.hostingSoftwareId = 27;
        this.statusBtnNext();
      }
    });

    this.formCapacidadTecnica.reset();
    this.selectCapacidadTecnica = null;
  }
  //#endregion

  //#region Capacidad Operativa
  onAgregarCapacidadOperativa() {
    this.capacidadOperativaService
      .create({
        ...this.formCapacidadOperativa.value,
        codigo_camara: this.rnt.codigo_camara,
        detalle_solicitud_id: this.rnt.detalle_solicitud_id,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          if (
            (this.datoSolicitudSharedModel.data.estado_rnt_id ===
              EstadosRnt.SuspendidoPorNoRenovar &&  
              this.datoSolicitudSharedModel.tipo_solicitud ===
              TipoSolicitud.Reactivacion) ||
            this.datoSolicitudSharedModel.tipo_solicitud ===
              TipoSolicitud.Renovacion ||
            this.datoSolicitudSharedModel.tipo_solicitud ===
              TipoSolicitud.Actualizacion
          ) {
            this.ratificaInformacion.cantidad_modificaciones += 1;
            this.completaInformacionService
              .confirmarCambio({ ...this.rnt, ...this.ratificaInformacion })
              .subscribe();
          }

          if (!this.capacidadesOperativas) {
            this.capacidadesOperativas = [] as Array<CapacidadOperativaEntry>;
          }

          this.capacidadesOperativas.push({
            ...resultado.data,
            descripcion: this.formacionEmpleo.find((buscar) => {
              if (
                this.formCapacidadOperativa.value.formacion_empleado_id ===
                buscar.formacion_empleado_id
              ) {
                return buscar;
              }
            }).descripcion,
          });
          this.formCapacidadOperativa.reset();
          this.statusBtnNext();
        }
      });
  }

  onModificarCapacidadOperativa() {
    this.capacidadOperativaService
      .update(this.formCapacidadOperativa.value)
      .subscribe((resultado) => {
        if (resultado.result) {
          if (
            (this.datoSolicitudSharedModel.data.estado_rnt_id ===
              EstadosRnt.SuspendidoPorNoRenovar &&  
              this.datoSolicitudSharedModel.tipo_solicitud ===
              TipoSolicitud.Reactivacion) ||
            this.datoSolicitudSharedModel.tipo_solicitud ===
              TipoSolicitud.Renovacion ||
            this.datoSolicitudSharedModel.tipo_solicitud ===
              TipoSolicitud.Actualizacion
          ) {
            this.ratificaInformacion.cantidad_modificaciones += 1;
            this.completaInformacionService
              .confirmarCambio({ ...this.rnt, ...this.ratificaInformacion })
              .subscribe();
          }
          const capacidadOperativa = this.formCapacidadOperativa
            .value as CapacidadOperativaEntry;
          capacidadOperativa.descripcion = this.formacionEmpleo.find(
            (buscar) => {
              if (
                this.formCapacidadOperativa.value.formacion_empleado_id ===
                buscar.formacion_empleado_id
              ) {
                return buscar;
              }
            }
          ).descripcion;
          this.capacidadesOperativas[
            this.capacidadesOperativas.indexOf(this.selectCapacidadOperativa)
          ] = capacidadOperativa;
          this.selectCapacidadOperativa = null;
          this.formCapacidadOperativa.reset();

          this.statusBtnNext();
        }
      });
  }

  onCargarEditarOperativa(entry: CapacidadOperativaEntry) {
    this.formCapacidadOperativa.setValue({
      formacion_empleado_id: entry.formacion_empleado_id,
      numero_empleados: entry.numero_empleados,
      capacidad_operativa_id: entry.capacidad_operativa_id,
      descripcion: entry.descripcion,
      codigo_camara: this.rnt.codigo_camara,
      detalle_solicitud_id: this.rnt.detalle_solicitud_id,
      activo: true,
    });
    this.selectCapacidadOperativa = entry;
  }

  onEliminarCapacidadOperativa(entry: CapacidadOperativaEntry) {
    this.capacidadOperativaService.delete(entry).subscribe((resultado) => {
      if (resultado.result) {
        if (
          this.datoSolicitudSharedModel.tipo_solicitud ===
            TipoSolicitud.Renovacion ||
          this.datoSolicitudSharedModel.tipo_solicitud ===
            TipoSolicitud.Actualizacion
        ) {
          this.ratificaInformacion.cantidad_modificaciones += 1;
          this.completaInformacionService
            .confirmarCambio({ ...this.rnt, ...this.ratificaInformacion })
            .subscribe();
        }
        this.capacidadesOperativas.splice(
          this.capacidadesOperativas.indexOf(entry),
          1
        );
        this.formCapacidadOperativa.reset();

        this.statusBtnNext();
      }
    });

    this.formCapacidadOperativa.reset();
    this.selectCapacidadOperativa = null;
  }

  onRegresarPaso(): void {
    this.rnt.paso = 1;
    if(this.datoSolicitudSharedModel.data.estado_rnt_id ===
      EstadosRnt.SuspendidoPorNoRenovar &&  
      this.datoSolicitudSharedModel.tipo_solicitud ===
      TipoSolicitud.Reactivacion){
        this.rnt.paso = 2;
      }

    if (
      (this.datoSolicitudSharedModel.data.estado_rnt_id ===
        EstadosRnt.SuspendidoPorNoRenovar &&  
        this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Reactivacion) ||
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Renovacion ||
      this.datoSolicitudSharedModel.tipo_solicitud ===
        TipoSolicitud.Actualizacion
    ) {
      const rnt: RNTPrestadorEntry = {
        ...this.rnt,
        tipo_solicitud_id: this.datoSolicitudSharedModel.tipo_solicitud,
      };
      this.completaInformacionService
        .update({ ...this.rnt, ...this.ratificaInformacion })
        .subscribe((resultado) => {
          if (resultado.result) {
            this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
              data: {
                ...rnt,
                ratificaInformacion: this.ratificaInformacion,
                nit: this.datoSolicitudSharedModel.data.nit,
              } as RNTPrestadorEntry,
              tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
              tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
              estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud,
            });
            if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Inmuebles) {
              this.router.navigate(["solicitud/completa-informacion-inmueble"]);
            } else {
              if (this.datoSolicitudSharedModel.tipo_rnt !== TipoRnt.Guia && this.datoSolicitudSharedModel.tipo_rnt !== TipoRnt.PlataformaDigitales) {
                this.router.navigate(["solicitud/completa-informacion"]);
              } else if(this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.PlataformaDigitales) {
                PlataformasElectronicasDigitalesFlow.conmutadorDePasosPlataformasDigitales(this.rnt.paso-1, this.router);
              }else {
                this.router.navigate(["solicitud/completa-informacion-guia"]);
              }
            }
          }
        });
    } else {
      this.completaInformacionService
        .update(this.rnt)
        .subscribe((resultado) => {
          if (resultado.result) {
            this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
              data: this.rnt as RNTPrestadorEntry,
              tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
              tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
              estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud,
            });
            if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Inmuebles) {
              this.router.navigate(["solicitud/completa-informacion-inmueble"]);
            } else {
              if (this.datoSolicitudSharedModel.tipo_rnt !== TipoRnt.Guia && this.datoSolicitudSharedModel.tipo_rnt !== TipoRnt.PlataformaDigitales) {
                this.router.navigate(["solicitud/completa-informacion"]);
              } else if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.PlataformaDigitales) {
                PlataformasElectronicasDigitalesFlow.conmutadorDePasosPlataformasDigitales(this.rnt.paso-1, this.router);
              }else {
                this.router.navigate(["solicitud/completa-informacion-guia"]);
              }
            }
          }
        });
    }
  }
  //#endregion

  //#region obtener Parametros

  InitGetParametroCapacidadTecnica() {
    this.completaInformacionService
      .getParametro({
        parametro_id: "TEXTO_TRATAMIENTO_DATOS_CAPACIDAD_TECNICA",
        agrupacion: "TRATAMIENTO_DATOS",
        auxiliar: "1",
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.Texto_Capacidad_tecnica =
            resultado.data !== ""
              ? resultado.data
              : " *Agregrar Descripcion desde el modulo parametro";

          this.completaInformacionService
            .getParametro({
              parametro_id: "TITULO_TRATAMIENTO_DATOS_CAPACIDAD_TECNICA",
              agrupacion: "TRATAMIENTO_DATOS",
              auxiliar: "1",
            })
            .subscribe((resultado2) => {
              if (resultado2.result) {
                this.Titulo_Capacidad_tecnica =
                  resultado2.data !== ""
                    ? resultado2.data
                    :" * Agregar Titulo descripcion desde el modulo parametro ";
              }
            });
        }
      });
  }

  InitGetParametroCapacidadOperativa() {

    this.completaInformacionService
    .getParametro({
      parametro_id: "TEXTO_TRATAMIENTO_DATOS_CAPACIDAD_OPERATIVO",
      agrupacion: "TRATAMIENTO_DATOS",
      auxiliar: "1",
    })
    .subscribe((resultado) => {
      if (resultado.result) {
        this.Texto_Capacidad_Operativa =
          resultado.data !== ""
            ? resultado.data
            : " * Agregrar Descripcion desde el modulo parametro";

        this.completaInformacionService
          .getParametro({
            parametro_id: "TITULO_TRATAMIENTO_DATOS_CAPACIDAD_OPERATIVA",
            agrupacion: "TRATAMIENTO_DATOS",
            auxiliar: "1",
          })
          .subscribe((resultado2) => {
            if (resultado2.result) {
              this.Titulo_Capacidad_Operativa =
                resultado2.data !== ""
                  ? resultado2.data
                  :" * Agregar Titulo descripcion desde el modulo parametro ";
            }
          });
      }
    });

  }

  //#endregion


  // Solucion BUG777 y BUG778
  requiredClass: string = '';
  requiredClassOp: string = '';


  // Obtener Configuracion Capacidad (Tecnica y Operativa)
  getConfiguracionCapacidadTecnica(){
      let idCapacidadTecnica = TipoCapacidad.Tecnica;
      //let isComerciante = this.datoSolicitudSharedModel.data.tipo_rnt_id === TipoPrestadorId.Comerciante ? true : false;
      let isComerciante = this.datoSolicitudSharedModel.data.tipo_prestador_id === TipoPrestadorId.Comerciante ? true : false;

      this.capacidadTecnicaService.getConfigCapacidades(idCapacidadTecnica, this.idCategoria)
      .subscribe((response) => {
        if(response.result){
          if(response.data[0]){
            if(isComerciante){
              this.mostrarCapTecnica = response.data[0].Se_Muestra_Comerciante;
              this.requeridoCapTecnica = response.data[0].Obligatorio_Muestra_Comerciante;
              this.requiredClass = response.data[0].Obligatorio_Muestra_Comerciante ? 'required2' : '';
            } else {
              this.mostrarCapTecnica = response.data[0].Se_Muestra_No_Comerciante;
              this.requeridoCapTecnica = response.data[0].Obligatorio_Muestra_No_Comerciante;
              this.requiredClass = response.data[0].Obligatorio_Muestra_No_Comerciante ? 'required2' : '';
            }

            this.statusBtnNext();
          } else{
            console.log('___WARNING, NO DATA FOUND');
          }
        } else{
          console.log('___ERROR, WEB SERVICE');
        }
      });
  }

  getConfiguracionCapacidadOperativa(){
    let idCapacidadTecnica = TipoCapacidad.Operativa;
    //let isComerciante = this.datoSolicitudSharedModel.data.tipo_rnt_id === TipoPrestadorId.Comerciante ? true : false;
    let isComerciante = this.datoSolicitudSharedModel.data.tipo_prestador_id === TipoPrestadorId.Comerciante ? true : false;

    this.capacidadTecnicaService.getConfigCapacidades(idCapacidadTecnica, this.idCategoria)
    .subscribe((response) => {
      if(response.result){
        if(response.data[0]){
          if(isComerciante){
            this.mostrarCapOperativa = response.data[0].Se_Muestra_Comerciante;
            this.requeridoCapOperativa = response.data[0].Obligatorio_Muestra_Comerciante;
            this.requiredClassOp = response.data[0].Obligatorio_Muestra_Comerciante ? 'required2' : '';
          } else {
            this.mostrarCapOperativa = response.data[0].Se_Muestra_No_Comerciante;
            this.requeridoCapOperativa = response.data[0].Obligatorio_Muestra_No_Comerciante;
            this.requiredClassOp = response.data[0].Obligatorio_Muestra_No_Comerciante ? 'required2' : '';
          }
        } else{
          console.log('___WARNING, NO DATA FOUND');
        }

        this.statusBtnNext();
      } else{
        console.log('___ERROR, WEB SERVICE');
      }
    });
  }

  // Estado boton 'Siguiente'
  isDisableBtn: boolean = true;
  statusBtnNext(){
    if(this.requeridoCapTecnica && this.requeridoCapOperativa){ // CT y CO Requeridas
      if(!this.capacidadesTecnicas || this.capacidadesTecnicas.length === 0 || !this.capacidadesOperativas ||
        this.capacidadesOperativas.length === 0){
        this.isDisableBtn = true;
      } else if(this.capacidadesTecnicas || this.capacidadesTecnicas.length > 0 || this.capacidadesOperativas ||
        this.capacidadesOperativas.length > 0){
          this.isDisableBtn = false;
      }
    } else if(this.requeridoCapTecnica && !this.requeridoCapOperativa){ // CT Requerida - CO No Requerida
      if(!this.capacidadesTecnicas || this.capacidadesTecnicas.length === 0){
        this.isDisableBtn = true;
      } else if(this.capacidadesTecnicas || this.capacidadesTecnicas.length > 0){
        this.isDisableBtn = false;
      }
    } else if(!this.requeridoCapTecnica && this.requeridoCapOperativa){ // CT No requerida - CO Requerida
      if(!this.capacidadesOperativas || this.capacidadesOperativas.length === 0){
        this.isDisableBtn = true;
      } else if(this.capacidadesOperativas || this.capacidadesOperativas.length > 0){
        this.isDisableBtn = false;
      }
    } else if(!this.requeridoCapTecnica && !this.requeridoCapOperativa){ // No requerida la CT y CO
      this.isDisableBtn = false;
    }
  }
}
